import { PartnershipMapper } from "../../domain/mappers/PartnershipMapper";
import { PartnershipValidation } from "../../domain/entities/PartnershipValidation";
import { PartnershipValidationResponse } from "../dtos/responses/PartnershipValidationResponse";

export class PartnershipMapperImpl implements PartnershipMapper<PartnershipValidationResponse> {
  toDomain(data: PartnershipValidationResponse): PartnershipValidation {
    return {
      should_show_warning: !data.can_have_appointment,
      can_have_free_appointment: data.can_have_appointment,
      message: data.message,
    };
  }
}
